import * as React from 'react';

import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkIcon } from 'uitk-react-icons';
import { DisclaimerDialog } from 'src/common/components/common/disclaimer-dialog';
import { ClickTracker } from 'bernie-analytics';
import { Link } from 'react-router-dom';
import { StrikeoutPrice } from './strikeout-price';

const LinkTracked = ClickTracker(Link);

export interface StrikeoutPriceAndInfoContainerProps {
  strikeoutDisclaimer?: string;
  strikeOut?: string;
  query?: any;
  dialogId?: string;
  handleClose?: () => void;
  wrapPrice?: boolean;
  dialogType?: string;
}

export const StrikeoutPriceAndInfoContainer: React.FunctionComponent<StrikeoutPriceAndInfoContainerProps> = ({
  strikeoutDisclaimer,
  query,
  strikeOut,
  dialogId,
  handleClose,
  wrapPrice,
  dialogType
}) => (
  <React.Fragment>
    {strikeoutDisclaimer ? (
      <React.Fragment>
        <UitkMoreInfoTrigger>
          <LinkTracked linkName="Price Disclaimer Dialog" rfrr=".Price.DisclaimerDialog" to={query}>
            <UitkIcon name="info_outline" className="pwa-theme--grey-700" />
            <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
          </LinkTracked>
        </UitkMoreInfoTrigger>
        <DisclaimerDialog
          dialogType={dialogType}
          disclaimerText={strikeoutDisclaimer}
          innerHTML={true}
          layerId="price-disclaimer-dialog"
          disclaimerTextId="price-disclaimer-text"
          {...{ dialogId, handleClose }}
        />
      </React.Fragment>
    ) : (
      <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
    )}
  </React.Fragment>
);
